import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TwitterComponent } from '../twitter/twitter.component';
import { FacebookComponent } from '../facebook/facebook.component';
import { LinkedinComponent } from '../linkedin/linkedin.component';

@Component({
  selector: 'app-navigation-footer',
  imports: [RouterModule,CommonModule,TwitterComponent,FacebookComponent,LinkedinComponent],
  templateUrl: './navigation-footer.component.html',
  styleUrl: './navigation-footer.component.scss',
})
export class NavigationFooterComponent {
  public currentYear: number = new Date().getFullYear();

}
